/**
 * Defines the feature type codes as constants.
 * These codes are some of the codes which are present in the feature type config files.
 */
export const FEATURE_TYPE_CODE = {
  PRIORITY_AREA_INTERVENTION_MAIN: 'priority_areas_for_intervention_main',
  PRIORITY_AREA_INTERVENTION_CROSSSECTION: 'priority_areas_for_intervention_crosssection',
} as const

export type FEATURE_TYPE_CODE_TYPE = (typeof FEATURE_TYPE_CODE)[keyof typeof FEATURE_TYPE_CODE]

/**
 * Feature type codes which are needed for linking project goals.
 * This feature types are required to be present in order to link goals properly.
 */
export const PROJECT_GOAL_RELATED_FEATURE_CODES = {
  PRIORITY_AREA_INTERVENTION_MAIN: FEATURE_TYPE_CODE.PRIORITY_AREA_INTERVENTION_MAIN,
  PRIORITY_AREA_INTERVENTION_CROSSSECTION: FEATURE_TYPE_CODE.PRIORITY_AREA_INTERVENTION_CROSSSECTION,
} as const
